var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('mbgl',{staticClass:"map"}),_c('nav-drawer'),_c('v-img',{staticClass:"legend",attrs:{"src":require("@/assets/legend.png"),"width":"75"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }